import { AutoSizer, List } from 'react-virtualized';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import styles from './index.module.scss';

const MembersList = ({
  title,
  count,
  members,
}: {
  title: string;
  count: number;
  members: ChatGroupMember[];
  loading?: boolean;
}) => {
  const memberRowRenderer = ({ index, style }: any) => {
    const member = members[index];
    return (
      <div className={styles.memberItem} key={member.user_id} style={style}>
        <img src={member.avatar} />
        <div className={styles.info}>
          <div className={styles.name}>{member.name}</div>
          {member?.username && (
            <div className={styles.shortName}>@{member?.username}</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.list}>
      <div className={styles.title}>
        <span>{count}</span>
        <span>{title}</span>
      </div>
      <div className={styles.vList}>
        <AutoSizer>
          {({ height, width }) => (
            <List
              className="scrollbar_hover"
              width={width}
              height={height}
              rowCount={members.length}
              rowHeight={36}
              rowRenderer={memberRowRenderer}
              noRowsRenderer={() => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
              scrollToIndex={0}
            />
          )}
        </AutoSizer>
      </div>
    </div>
  );
};

export default memo(MembersList);
